import { BlockInstanceProps } from '../Block';
import HeroComponent from '../../components/Hero';
import {
  ContentTypeEnum,
  HeroTypeEnum,
  BackgroundColorEnum,
} from '../../constants/cms-constants';
import {
  ComponentWithControlOptions,
  ControlOption,
} from '../../utils/controlOptions/ControlOptionDecorator';
import controlOptionDefinitions from '../../utils/controlOptions/controlOptionDefinitions';

@ControlOption([
  {
    key: 'type',
    definition: controlOptionDefinitions.heroTypes,
  },
  {
    key: 'backgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  { key: 'seoWeight', definition: controlOptionDefinitions.SEOWeightTypes },
])
class HeroBlock extends ComponentWithControlOptions<BlockInstanceProps> {
  render() {
    const { block, blockContent } = this.props;
    const controlOptions = block?.controlOptionsV2;
    const backgroundColor =
      BackgroundColorEnum[controlOptions?.backgroundColor];
    const type = HeroTypeEnum[controlOptions?.type];
    const seoWeight = controlOptions?.seoWeight;

    let image;
    let video;
    blockContent.doQuery((content) => {
      image = content.getFirstOfType(ContentTypeEnum.IMAGE, false);
      video = content.getFirstOfType(ContentTypeEnum.VIDEO, false);
    });

    return (
      <HeroComponent
        mainHeader={block?.header?.main}
        lightHeader={block?.header?.light}
        bodyText={block?.bodyText}
        image={image}
        video={video}
        type={type}
        link={block?.link}
        backgroundColor={backgroundColor}
        seoWeight={seoWeight}
      />
    );
  }
}

export default HeroBlock;
